import { render } from "./custom-image.vue?vue&type=template&id=be05338a"
import script from "./custom-image.vue?vue&type=script&lang=js"
export * from "./custom-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__